import { initMenuList } from '@/assets/mock/mock'

let menuList = initMenuList;
function isURL (s) {
  return /^http[s]?:\/\/.*/.test(s)
}

/**
 * 添加动态(菜单)路由
 * @param {*} menuList 菜单列表
 * @param {*} routes 递归创建的动态(菜单)路由
 */
export function fnAddDynamicMenuRoutes (menuList = [], routes = []) {
  var temp = []
  for (var i = 0; i < menuList.length; i++) {
    if (menuList[i].children && menuList[i].children.length >= 1) {
      temp = temp.concat(menuList[i].children)
      continue
    }
    // 组装路由
    var route = {
      path: '',
      component: null,
      name:'',
      meta: {
        menuId: menuList[i].id,
        title: menuList[i].name
      }
    }
    // eslint-disable-next-line
    let URL = (menuList[i].url || '').replace(/{{([^}}]+)?}}/g, (s1, s2) => eval(s2)) // URL支持{{ window.xxx }}占位符变量
    if (isURL(URL)) {
      route['path'] = route['name'] = `i-${menuList[i].id}`
      route['meta']['iframeURL'] = URL
    } else {
      URL = URL.replace(/^\//, '').replace(/_/g, '-')
      route['path'] = route['name'] = '/' + URL.replace(/\//g, '/')
      route['component'] = () => import(`@/views/${URL}`)
    }
    routes.push(route)
  }
  if (temp.length >= 1) {
    return fnAddDynamicMenuRoutes(temp, routes)
  }
  window.config['menuRoutes'] = routes
}

/**
 * 判断当前路由是否为页面路由
 * @param {*} route 当前路由
 * @param {*} pageRoutes 页面路由
 */
export function fnCurrentRouteIsPageRoute (route, pageRoutes = []) {
  var temp = []
  for (var i = 0; i < pageRoutes.length; i++) {
    if (route.path === pageRoutes[i].path) {
      return true
    }
    if (pageRoutes[i].children && pageRoutes[i].children.length >= 1) {
      temp = temp.concat(pageRoutes[i].children)
    }
  }
  return temp.length >= 1 ? fnCurrentRouteIsPageRoute(route, temp) : false
}

fnAddDynamicMenuRoutes(menuList)
//将生成路由导入合并
const routes = [
  { path:'/', redirect:'/login' },
  {
    path: '/login',
    component: () => import('@/views/login'),
    name: 'login',
    meta: { title: '登录' } 
  },
  { 
    path: '/home',
    redirect:'/acco-query/asset-overview', 
    component: () => import('@/views/home'), 
    meta: { title: '首页'},
    children: [
      ...window.config['menuRoutes'],
      // 查看历史测评
      {
        path: '/acco-query/history-risk',
        component: () => import('@/views/acco-query/history-risk'),
        name: 'historyRisk',
        meta: { title: 'historyRisk', menuId: '1067246875800000025', keepAlive: true }
      },
      // 申购交易
      {
        path: '/fund-trans/sub-trans',
        component: () => import('@/views/fund-trans/sub-trans.vue'),
        name: 'subTrans',
        meta: { title: 'subTrans', menuId: '22', keepAlive: true }
      },
      // 基金详情
      {
        path: '/fund-trans/fund-detail',
        component: () => import('@/views/fund-trans/fund-detail.vue'),
        name: 'fundDetail',
        meta: { title: 'fundDetail', menuId: '', keepAlive: true }
      },
      // 赎回交易
      {
        path: '/fund-trans/rede-trade',
        component: () => import('@/views/fund-trans/rede-trade.vue'),
        name: 'redeTrade',
        meta: { title: 'redeTrade', menuId: '23', keepAlive: true }
      },
      // 修改定投交易
      {
        path: '/fund-trans/fixed-inves-modify',
        component: () => import('@/views/fund-trans/fixed-inves-modify.vue'),
        name: 'modifyFixedInves',
        meta: { title: 'modifyFixedInves', menuId: '27', isFixed: true, keepAlive: true }
      },
      // 创建定投交易
      {
        path: '/fund-trans/fixed-inves-add',
        component: () => import('@/views/fund-trans/fixed-inves-add.vue'),
        name: 'addFixedInves',
        meta: { title: 'addFixedInves', menuId: '27', isFixed: true, keepAlive: true }
      },
      // 当前基金定投交易
      {
        path: '/fund-trans/curr-fixed-inves-add',
        component: () => import('@/views/fund-trans/curr-fixed-inves-add.vue'),
        name: 'addCurrFixedInves',
        meta: { title: 'addCurrFixedInves', menuId: '22', isFixed: true, keepAlive: true }
      },
      // 转换交易
      {
        path: '/fund-trans/trans-trade',
        component: () => import('@/views/fund-trans/trans-trade.vue'),
        name: 'transTrade',
        meta: { title: 'transTrade', menuId: '24', isFixed: true, keepAlive: true }
      },
      // 超宝立即充值
      {
        path: '/fund-trans/super-xjb/super-xjb-buy',
        component: () => import('@/views/fund-trans/super-xjb/super-xjb-buy.vue'),
        name: 'superXjbBuy',
        meta: { title: 'superXjbBuy', menuId: '28', isFixed: true, keepAlive: true }
      },
      // 超宝定期充值
      {
        path: '/fund-trans/super-xjb/super-xjb-avgr',
        component: () => import('@/views/fund-trans/super-xjb/super-xjb-avgr.vue'),
        name: 'superXjbAvgr',
        meta: { title: 'superXjbAvgr', menuId: '28', isFixed: true, keepAlive: true }
      },
      // 超宝取现
      {
        path: '/fund-trans/super-xjb/super-xjb-redeem',
        component: () => import('@/views/fund-trans/super-xjb/super-xjb-redeem.vue'),
        name: 'superXjbRedeem',
        meta: { title: 'superXjbRedeem', menuId: '28', isFixed: true, keepAlive: true }
      },
    ]
  },
  {
    path: '/forget',
    redirect:'/acco-query/asset-overview', 
    component: () => import('@/views/forget/index.vue'),
    name: 'test',
    meta: { title: 'forget' },
    children:[
      {
        path: 'activatePwd',
        component: () => import('@/views/forget/activatePwd.vue'),
        name: 'activatePwd',
        meta: { title: '交易密码激活页面' }
      },
      {
        path: 'goCreate',
        component: () => import('@/views/forget/goCreate.vue'),
        name: 'goCreate',
        meta: { title: '开户提示页面' }
      },
      {
        path: 'riskTest',
        component: () => import('@/views/forget/riskTest.vue'),
        name: 'riskTest',
        meta: { title: '风测' }
      },
      {
        path: 'notice',
        component: () => import('@/views/forget/notice.vue'),
        name: 'notice',
        meta: { title: '提醒与通知' }
      },
      {
        path: 'register',
        component: () => import('@/views/forget/register.vue'),
        name: 'register',
        meta: { title: '注册' }
      },
      {
        path: 'resetForm',
        component: () => import('@/views/forget/resetForm.vue'),
        name: 'resetForm',
        meta: { title: 'resetForm' } 
      },
      {
        path: 'choseCard',
        component: () => import('@/views/forget/choseCard.vue'),
        name: 'choseCard',
        meta: { title: 'choseCard' } 
      },
      {
        path: 'resetPassWord',
        component: () => import('@/views/forget/resetPassWord.vue'),
        name: 'resetPassWord',
        meta: { title: 'resetPassWord' } 
      },
      {
        path: 'creatAccount',
        component: () => import('@/views/forget/creatAccount.vue'),
        name: 'creatAccount',
        meta: { title: 'creatAccount' } 
      },
      {
        path: 'resetMore',
        component: () => import('@/views/forget/resetMore.vue'),
        name: 'resetMore',
        meta: { title: 'resetMore' } 
      },
      {
        path: 'forgetTradePswd',
        component: () => import('@/views/forget/forgetTradePswd.vue'),
        name: 'forgetTradePswd',
        meta: { title: 'forgetTradePswd' } 
      },
    ]
  },
  {
    path: '/bindMobile',
    component: () => import('@/views/bind-mobile/bind-mobile'),
    name: 'bindMobile',
    meta: { title: '绑定手机号' }
  },
  {
    path: '/bindMobile/setPswd',
    component: () => import('@/views/bind-mobile/set-pswd'),
    name: 'setPswd',
    meta: { title: '设置登录密码' }
  },
  {
    path: '/bindMobile/verifyPswd',
    component: () => import('@/views/bind-mobile/verify-pswd'),
    name: 'verifyPswd',
    meta: { title: '验证登录密码' }
  },
  {
    path: '/test',
    component: () => import('@/views/test'),
    name: 'test',
    meta: { title: '测试' }
  },
  { path: '/404', component: () => import('@/views/404') },
  { path:'*', redirect:'/404'},
];

window.config['menuRoutes'] = routes

console.log('路由',routes)

export default routes;